import React, { Component } from 'react';
import { Tooltip } from 'antd';
import intl from 'react-intl-universal';

class UndoButton extends Component {
    constructor (props) {
        super(props);
        this.state = {
            disabled: true,
            lastData: {},
        };
        this.listeners = [];
    }
    componentDidMount () {
        const PDFUI = this.PDFUI = window.pdfui;
        this.undoManager = {};
        this.listeners = [
            PDFUI.addViewerEventListener(UIExtension.UIEvents.openFileSuccess, () => {
                this.undoManager = {};
                this.setState({disabled: true});
            }),
            PDFUI.addViewerEventListener(UIExtension.UIEvents.undoRedoStoreChange, (undoRedoData, type = 'undoRedo', isEditing) => {
                if (type === 'clearAll') {
                    this.undoManager = {};
                    this.setState({disabled: true});
                    return ;
                }
                if (!undoRedoData) return ;
                let undoStackArray = [];
                if (type === 'touchUp' || type === 'pageEditor') {
                    undoStackArray = undoRedoData[0];
                } else {
                    this.undoRedoController = undoRedoData;
                    const undoRedoManager = undoRedoData.undoRedoManager;
                    undoStackArray = undoRedoManager.undoStack.stackArray;
                }
                if (!undoStackArray) return ;
                if (isEditing !== undefined) {
                    type += isEditing;
                }
                const undoStackArrayCache = this.undoManager[type] || [];
                const _undoStackArrayCache = [];
                undoStackArray.forEach(undoStackItem => {
                    let isItemInCache = false;
                    for (let index = 0; index < undoStackArrayCache.length; index++) {
                        const element = undoStackArrayCache[index];
                        if (
                            ((undoStackItem instanceof Array) && (element.data instanceof Array)) ? 
                            (element.data.join('') === undoStackItem.join('')) : 
                            (element.data === undoStackItem)
                        ) {
                            isItemInCache = true;
                            _undoStackArrayCache.push(element);
                            break;
                        }
                    }
                    if (!isItemInCache) {
                        _undoStackArrayCache.push({
                            type: type,
                            data: undoStackItem,
                            isEditing: isEditing,
                            time: Date.now()
                        });
                    }
                });
                this.undoManager[type] = _undoStackArrayCache;
                if (type === 'pageEditorfalse') {
                    delete this.undoManager['pageEditortrue'];
                }
                let total = 0;
                for (const key in this.undoManager) {
                    const info = this.undoManager[key];
                    total += info.length;
                }
                this.setState({disabled: total === 0});
            })
        ]
        document.body.addEventListener('keyup', this.keyupEvent = (e) => {
            let activeTag = document.activeElement.tagName.toLowerCase();
            if(['input','textarea'].indexOf(activeTag)>-1)return;
            this.addUndoEvent(e);
        });
    }
    componentWillUnmount () {
        document.body.removeEventListener('keyup', this.keyupEvent);
        this.listeners.forEach(destroy => destroy());
    }

    addUndoEvent (e) {
        const { disabled } = this.state;
        if (!disabled && !e.shiftKey && e.ctrlKey && e.keyCode === 90) {
            // ctrl + z
            this.handleUndo();
        }
    }

    handleUndo () {
        let lastData, arr = [];
        for (const key in this.undoManager) {
            const array = this.undoManager[key];
            array.forEach(item => {
                const time = item.time;
                if (lastData) {
                    if (lastData.time < time) {
                        lastData = item;
                        arr = array;
                    }
                } else {
                    lastData = item;
                    arr = array;
                }
            });
        }
        switch (lastData.type) {
            case 'touchUp': 
                if (arr[arr.length - 1].data.length > 1) {
                    this.PDFUI.eventEmitter.emit('exitTouchup');
                }
                this.PDFUI.getCurrentPDFDoc().then(doc => {
                    const touchup = doc.getTouchup();
                    touchup.handleEvent('Undo', true);
                });
                break;
            case 'pageEditortrue':
            case 'pageEditorfalse':
            case 'pageEditor': 
                const currentStatesName = this.PDFUI.pdfViewer.getStateHandlerManager().getCurrentStates().getStateName();
                if (currentStatesName === 'touch-up-editor') {
                    this.PDFUI.eventEmitter.emit('exitTouchup');
                }
                this.PDFUI.getCurrentPDFDoc().then(doc => {
                    const pageEditor = doc.getPageEditor();
                    pageEditor.undoRedo(currentStatesName!=='hand'&&lastData.isEditing, true);
                });
                break;
            default:
                const undoRedoController = this.undoRedoController;
                undoRedoController && undoRedoController.undo();
                break;
        }
        this.setState({ lastData });
    }
    
    render () {
        const { disabled } = this.state;
        return (
            <Tooltip title={intl.get('HeaderContainer.undo')}>
                <i className={`icon-btn ${this.props.className} ` + (disabled ? ' disabled' : '')} style={{'textAlign': 'center', 'paddingTop': '4px'}} onClick={()=>!disabled&&this.handleUndo()}>
                    {this.props.icon ? <img src={this.props.icon} /> : <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
                        <path d='M5.5 14H3.5C3.22386 14 3 14.2238 3 14.5C3 14.7761 3.22386 15 3.5 15H5.5C5.77614 15 6 14.7761 6 14.5C6 14.2238 5.77614 14 5.5 14Z' fill='currentColor' />
                        <path
                          d='M7 15.002H5V14.002H6.77734C10.2073 14.002 12.998 11.537 12.998 8.502C12.998 5.467 10.2073 3.002 6.77734 3.002H5V2.002H7C8.78876 1.94113 10.5283 2.59053 11.8398 3.8084C13.1514 5.02627 13.9284 6.71364 14 8.502C13.9289 10.2905 13.1535 11.9781 11.8418 13.1961C10.5301 14.4141 8.7889 15.0634 7 15.002Z'
                          fill='currentColor' />
                        <path d='M1.99902 2.5C1.99902 2.22386 2.22288 2 2.49902 2H4.99902V3H2.49902C2.22288 3 1.99902 2.77614 1.99902 2.5Z' fill='currentColor' />
                        <path d='M4.49902 4.5L2.49902 2.5L4.49902 0.5' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
                    </svg>}
                </i>
            </Tooltip>
        );
    }
}

export default UndoButton;
